import styled from "styled-components";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.25);
  margin: 3rem 0;
`;

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
  padding-bottom: 1rem;
`;

export const StatisticsContainer = styled.div`
  display: flex;
  padding: 0;
  gap: 0.5rem;
  flex-direction: column;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    flex-direction: row;
  }

  @media print {
    page-break-after: always;
  }
`;

export const ChartTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 37.5%;
  }
`;

export const ChartDescriptionContainer = styled.div`
  padding: 1rem;
  flex: 1;
  flex-direction: column;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    > div {
      text-align: justify;
      text-justify: inter-word;
    }
  }
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  margin-top: 2rem;
  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 62.5%;
    height: 250px;
  }
  .highcharts-container {
    z-index: auto !important;
  }

  .highcharts-contextmenu {
    z-index: 1 !important;
  }
`;
